export enum ContainerAcl {
  None = 0,
  CreateGeozone = 1 << 0,
  EditGeozone = 1 << 1,
  CreateDriverKey = 1 << 2,
  EditDriverKey = 1 << 3,
  DeleteGeozone = 1 << 4,
  DeleteDriverKey = 1 << 5,
  EditGroup = 1 << 6,
  ManageMembers = 1 << 7,
  ManagePermissions = 1 << 8,
  DeleteContainer = 1 << 9,
  CreateReportTemplate = 1 << 10,
  EditReportTemplate = 1 << 11,
  DeleteReportTemplate = 1 << 12,
  CreateDriver = 1 << 13,
  EditDriver = 1 << 14,
  DeleteDriver = 1 << 15,
  ReadGeozone = 1 << 16,
  ReadDriverKey = 1 << 17,
  ReadReportTemplate = 1 << 18,
  ReadDriver = 1 << 19
}
